import React, { FC } from "react"

import { InputButtonGenericContainer, InputButtonGeneric } from "./styles"
import { InputButtonProps } from "./types"

export const InputButton: FC<InputButtonProps> = ({ isDisabled, ...props }) => {
  return (
    <InputButtonGenericContainer>
      <InputButtonGeneric
        {...props}
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation()
          props.onClick(event)
        }}
        disabled={isDisabled}
      />
    </InputButtonGenericContainer>
  )
}
